import { action, observable, makeObservable } from 'mobx';
import {SuccessResponse, userLoaders} from '../../../../domain';
import {HttpPromiseState} from '../../../../lib/helpers';

export class DeleteUserStore {
  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly userId: number) {
    makeObservable(this);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.save = userLoaders.delete(this.userId);
  }
}
